import {
  Button,
  Checkbox,
  Col,
  Image,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from 'antd';
import {Link} from 'react-router-dom';
import Title from 'antd/es/typography/Title';
import moment from 'moment';
import {SearchOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import {get, isEqual} from 'lodash';

import {PromoCodeService} from './PromoCodeService';
import {useEffect, useRef, useState} from 'react';
import {
  Gender,
  Level,
  Package,
  Promocode,
  PromocodeConnection,
  School,
  SchoolsConnection,
  Student,
  Studentconversation,
  StudentsConnection,
  Student_Status,
  Userconversation,
  Curriculum,
  Classschool,
} from '../../graphql/API';

import {useDispatch, useSelector} from 'react-redux';

import {getCurrentUserPermission, Permissions} from '../../utils';
import Text from 'antd/lib/typography/Text';
import {PackagesService} from '../Package';
import {SchoolsDropDown} from './SchoolsDropDown';
import {LevelsService} from '../Level';
import {CurriculumsService} from '../Curriculums/CurriculumsService';
import {NotificationPlacement} from 'antd/lib/notification';

const promoCodeService = new PromoCodeService();
const packagesService = new PackagesService();
const levelService = new LevelsService();

const curriculumsService = new CurriculumsService();

export const PromoCodeTable = () => {
  const dispatch = useDispatch();

  const [promoCodes, setPromoCodes] = useState<PromocodeConnection>();
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showCreationPopUp, setShowCreationPopUp] = useState<boolean>(false);
  const [levels, setLevels] = useState<Array<Level> | []>([]);
  const [levelId, setLevelId] = useState<string | undefined>(undefined);
  const [schoolId, setSchoolId] = useState<string | undefined>(undefined);
  const [classId, setClassId] = useState<string | undefined>(undefined);

  const [curriculums, setCurriculums] = useState<Array<Curriculum> | []>([]);

  const [current, setCurrent] = useState(1);
  const [maxNumReachedPages, setMaxNumReachedPages] = useState(1);
  const [sessionPerWeek, setSessionPerWeek] = useState<number>(1);

  const [numOfCodes, setNumOfCodes] = useState<number>(0);
  const Timeout = useRef<any>();
  const [emptySeachValue, setEmptySeachValue] = useState<boolean>(true);
  const [isSubscriptionSchool, setIsSubscriptionShool] =
    useState<boolean>(false);

  const [packages, setPackages] = useState<Array<Package> | []>([]);
  const [selectedPackage, setSelectedPackage] = useState<Package>();
  const [selectedCurriculum, setSelectedCurriculum] = useState<Curriculum>();

  const [currentUserPermission, setCurrentUserPermission] =
    useState<Permissions>();

  const [api, contextHolder] = notification.useNotification();

  const openErrorNotification = (
    placement: NotificationPlacement,
    message: string,
  ) => {
    api.error({
      // key,
      message: 'Cannot generate codes',
      description: message,
      placement,
    });
  };

  useEffect(() => {
    getCurrentUserPermission()
      .then((p: Permissions) => {
        //console.log('currentUserPermission', p);
        setCurrentUserPermission(p);
        if (p === 'admin') {
          packagesService
            .getPackages()
            .then((pkgs) => {
              //console.log('pkgs', pkgs);
              const livePackages = pkgs;
              //console.log('livePackages', livePackages);

              setPackages(livePackages);
            })
            .catch((error) => {
              setIsError(true);
              //console.log('Error ->', error);
            });

          curriculumsService
            .getCurriculums()
            .then((resp) => {
              setIsLoading(false);
              setCurriculums(resp);
              const selectedCurriculum = resp?.find(
                (curr: Curriculum) => curr?.id === 'PIKADO',
              );
              setSelectedCurriculum(selectedCurriculum);
            })
            .catch((error) => {
              setIsError(true);
              //console.log('Error ->', error);
            });
        }
      })
      .catch((er) => {
        //console.log('err->', er);
      });
  }, []);

  useEffect(() => {
    if (emptySeachValue && current && currentUserPermission) {
      if (currentUserPermission === 'admin') {
        promoCodeService
          .getPromoCodes(promoCodes?.nextToken)
          .then((resp: PromocodeConnection) => {
            const currentItems = promoCodes?.items ?? [];
            //console.log('promoCodes', resp);

            setPromoCodes({
              ...promoCodes,
              ...resp,
              items: [...currentItems, ...resp.items],
            });

            setIsLoading(false);
          })
          .catch((error) => {
            setIsError(true);
            //console.log('Error ->', error);
          });
      } else {
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, emptySeachValue, currentUserPermission]);

  useEffect(() => {
    if (!isSubscriptionSchool) {
      setLevelId(undefined);
      setSchoolId(undefined);
      setClassId(undefined);
    }

    if (isSubscriptionSchool && levels.length === 0) {
      levelService
        .getLevels()
        .then((lvls) => {
          setLevels(lvls);
        })
        .catch((error) => {
          setIsError(true);
          //console.log('Error ->', error);
        });
    }
  }, [isSubscriptionSchool, levels]);

  const columns: any = [
    {
      title: 'Code',
      dataIndex: 'codeName',
      sorter: (a: any, b: any) => {
        return a.codeName.localeCompare(b.codeName);
      },
    },

    {
      title: 'Package',
      dataIndex: ['package', 'name_i18n'],
      render: (name_i18n: string) => <p>{JSON.parse(name_i18n)['en']}</p>,
    },

    {
      title: 'Status',
      dataIndex: 'isApplied',
      render: (isApplied: boolean) => (
        <p
          style={{
            backgroundColor: isApplied ? 'red' : 'greenyellow',
            textAlign: 'center',
            padding: 2,
            color: isApplied ? 'white' : 'black',
            fontWeight: 'bold',
            borderRadius: 4,
          }}>
          {isApplied ? 'USED' : 'AVAILABLE'}
        </p>
      ),
    },
    {
      title: 'sessions/week',
      dataIndex: 'sessionPerWeek',
      render: (sessionPerWeek: number) => (
        <p
          style={{
            textAlign: 'center',
            padding: 2,
            color: 'black',
            fontWeight: 'bold',
            borderRadius: 4,
          }}>
          {sessionPerWeek}
        </p>
      ),
    },

    {
      title: 'Student id',
      dataIndex: ['student', 'id'],
      render: (id: string, record: Promocode) => (
        <Link
          to={{
            pathname: '/students/' + record?.student?.id + '/edit',
            state: {student: record.student},
          }}>
          {id}
        </Link>
      ),
      filterSearch: true,
    },
    {
      title: 'school',
      dataIndex: 'school',
      render: (school: School) => (
        <p
          style={{
            textAlign: 'center',
            padding: 2,
            color: 'black',
            fontWeight: 'bold',
            borderRadius: 4,
          }}>
          {school?.name}
        </p>
      ),
    },
    {
      title: 'level',
      dataIndex: 'level',
      render: (level: Level) => (
        <p
          style={{
            textAlign: 'center',
            padding: 2,
            color: 'black',
            fontWeight: 'bold',
            borderRadius: 4,
          }}>
          {level?.name}
        </p>
      ),
    },
    {
      title: 'Program',
      dataIndex: ['package', 'program', 'flag'],
      render: (flag: string) => (
        <img style={{width: 60, height: 40}} src={flag} />
      ),
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      defaultSortOrder: 'descend',
      sorter: (a: any, b: any) =>
        moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
  ];

  const onChangeLogic = ({current}, size) => {
    //console.log('CURRRRR_sizeChangeLogic', current);

    if (current >= maxNumReachedPages) {
      setCurrent(current);
      setMaxNumReachedPages(current);
    }
  };

  const searchStudents = (nextToken: string, textSearch?: string) => {
    if (textSearch.length > 0 || currentUserPermission === 'editor') {
      promoCodeService
        .getPromoCodes(nextToken, textSearch)
        .then((codes) => {
          setPromoCodes({
            ...codes,
          });
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //console.log('Error ->', error);
        });
    }
  };

  return (
    <>
      {contextHolder}

      <Row
        style={{
          margin: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Col>
          <Input
            style={{marginTop: 10}}
            placeholder="Search Code"
            onChange={(event) => {
              setIsLoading(true);
              if (event.target.value.length === 0) {
                setEmptySeachValue(true);
              } else {
                setEmptySeachValue(false);
              }

              if (Timeout.current) {
                clearTimeout(Timeout.current);
              }

              Timeout.current = setTimeout(() => {
                searchStudents(null, event.target.value);
              }, 1200);
            }}
          />
        </Col>
        {currentUserPermission === 'admin' && !isLoading && (
          <Col>
            <Button size={'large'} onClick={() => setShowCreationPopUp(true)}>
              Create
            </Button>
          </Col>
        )}
      </Row>
      {!isError && !isLoading && (
        <Table
          pagination={{pageSizeOptions: ['100'], pageSize: 100}}
          current={current}
          defaultPageSize={100}
          // onShowSizeChange={sizeChangeLogic}
          onChange={onChangeLogic}
          // showSizeChanger={true}
          columns={columns}
          dataSource={promoCodes?.items}
        />
      )}
      <Modal
        visible={showCreationPopUp}
        // closable={true}
        onCancel={() => {
          setShowCreationPopUp(false);
        }}
        okText="Create"
        onOk={async () => {
          if (
            numOfCodes > 0 &&
            numOfCodes <= 100 &&
            selectedPackage?.id &&
            sessionPerWeek &&
            selectedCurriculum?.id
          ) {
            if (schoolId && !classId) {
              openErrorNotification(
                'topRight',
                `If you select school you must select the class`,
              );

              return;
            }

            setShowCreationPopUp(false);

            setIsLoading(true);
            const schoolIdd = isSubscriptionSchool ? schoolId : undefined;
            const lvlId = isSubscriptionSchool ? levelId : undefined;

            await promoCodeService.createPromoCodes(
              numOfCodes,
              selectedPackage.id,
              sessionPerWeek,
              schoolIdd,
              classId,
              lvlId,
              selectedCurriculum.id,
            );

            window.location.reload();
          }
        }}>
        <div>
          <Row>
            <Col span={11} style={{marginInlineEnd: 10}}>
              <Text style={{display: 'block'}} strong={true}>
                Number of promo codes
              </Text>

              <Input
                placeholder={'How much to generate'}
                onChange={(e: any) => setNumOfCodes(e.target.value)}
                value={numOfCodes}
              />
              {numOfCodes <= 0 && (
                <Text
                  style={{
                    display: 'block',
                    fontSize: 10,
                    fontWeight: 'normal',
                    color: 'red',
                  }}
                  strong={true}>
                  Number of codes must be greater than zero and less than 100
                </Text>
              )}
            </Col>
            <Col span={11}>
              <Text style={{display: 'block'}} strong={true}>
                Package
              </Text>
              <Select
                value={selectedPackage?.id}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a package"
                optionFilterProp="children"
                onChange={(pkgId) => {
                  let selectedPackage = packages.find(
                    // @ts-ignore
                    (pkg) => pkg.id === pkgId,
                  );

                  setSelectedPackage(selectedPackage);
                }}>
                {packages?.map((pkg) => (
                  <Select.Option value={pkg.id!}>
                    {JSON.parse(pkg.name_i18n)['en']}
                  </Select.Option>
                ))}
              </Select>

              {!selectedPackage?.id && (
                <Text
                  style={{
                    display: 'block',
                    fontSize: 10,
                    fontWeight: 'normal',
                    color: 'red',
                  }}
                  strong={true}>
                  field required *
                </Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={11} style={{marginTop: 10}}>
              <Text style={{display: 'block'}} strong={true}>
                Curriculum
              </Text>
              <Select
                defaultValue="PIKADO"
                value={selectedCurriculum?.id}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a Curriculum"
                optionFilterProp="children"
                onChange={(currlId) => {
                  let selectedCurriculum = curriculums?.find(
                    // @ts-ignore
                    (curr) => curr.id === currlId,
                  );

                  setSelectedCurriculum(selectedCurriculum);
                }}>
                {curriculums?.map((curr: Curriculum) => (
                  <Select.Option value={curr.id!}>{curr.name}</Select.Option>
                ))}
              </Select>

              {!selectedCurriculum?.id && (
                <Text
                  style={{
                    display: 'block',
                    fontSize: 10,
                    fontWeight: 'normal',
                    color: 'red',
                  }}
                  strong={true}>
                  field required *
                </Text>
              )}
            </Col>
          </Row>
          <Row>
            <Text
              style={{
                display: 'block',
                marginTop: '20px',
                marginBottom: '10px',
              }}
              strong={true}>
              Number of sesson per week
            </Text>
          </Row>
          <Row>
            {selectedPackage?.sessionPerWeek?.map((number: number | null) => (
              <div
                style={{
                  alignItems: 'center',
                  flexDirection: 'row',
                  display: 'flex',
                }}>
                <button
                  style={{
                    width: 25,
                    height: 25,
                    backgroundColor: '#fff',
                    borderRadius: 25,
                    marginEnd: 11,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderColor: 'red',
                    borderWidth: 1,
                    marginInline: 20,
                    display: 'flex',
                  }}
                  onClick={() => setSessionPerWeek(number ?? 1)}>
                  {number === sessionPerWeek && (
                    <div
                      style={{
                        width: 12,
                        height: 12,
                        backgroundColor: '#F2406A',
                        borderRadius: 6,
                      }}
                    />
                  )}
                </button>
                <Text>{number}</Text>
              </div>
            ))}
          </Row>

          <div style={{marginTop: '20px', marginBottom: '20px'}}>
            <Checkbox
              checked={isSubscriptionSchool}
              onChange={() => setIsSubscriptionShool(!isSubscriptionSchool)}>
              subscription code for school
            </Checkbox>

            {isSubscriptionSchool && (
              <>
                <SchoolsDropDown
                  onSelectClass={function (classschool: Classschool): void {
                    // throw new Error('Function not implemented.');
                    setClassId(classschool?.id);
                  }}
                  onSelectSchool={function (school: School): void {
                    // throw new Error('Function not implemented.');
                    setSchoolId(school?.id);
                  }}
                />
                <div style={{marginTop: 30}}>
                  <Select
                    value={levelId}
                    showSearch
                    style={{width: '100%'}}
                    placeholder="Select a level"
                    optionFilterProp="children"
                    onChange={(lvlId) => setLevelId(lvlId)}>
                    {levels?.map((lvl) => (
                      <Select.Option value={lvl.id!}>{lvl.name}</Select.Option>
                    ))}
                  </Select>
                </div>
              </>
            )}
          </div>
        </div>
      </Modal>

      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Subscription codes fetching error ⚠️</Title>}
    </>
  );
};
